import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AuthService} from '@core/services/auth.service';

@Injectable()
export class InterceptorsService implements HttpInterceptor {

    constructor(private auth: AuthService) {
    }

    /** перехватчик состояния запросов к api */
    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = req.clone({withCredentials: true});
        const auth = localStorage.getItem('token');
        if (auth) {
            authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${auth}`
                },
                withCredentials: false
            });
        }
        return next.handle(authReq)
            .pipe(
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {

                    }
                    return event;
                }),
                catchError((err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if ([401, 429].includes(err.status)) {
                            // this.auth.clearUser();
                        }
                    }
                    throw err;
                })
            );
    }
}
